export default {
    data: () => ({
        isDesktop: screen.width > 1024,
        isMobile: screen.width < 768,
        isTablet: screen.width >= 768 && screen.width <= 1024,
    }),
    methods: {
        getDeviceName: function(actualScreen) {
            const width = actualScreen.left || actualScreen.width

            if (width < 768) {
                return 'mobile'
            }

            if (width > 1024) {
                return 'desktop'
            }

            return 'tablet'
        }
    },
}
